export const openChat = () => window.Intercom('showNewMessage')
